import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type React from "react";
import { useAuth } from "../contexts/AuthProvider";

import { INK, INK_BLACK, NEUTRAL } from "../theme/tokens";
import { TermsContent } from "./TermsContent";

interface TermsAndConditionsDialogProps {
	open: boolean;
}

export const TermsAndConditionsDialog: React.FC<TermsAndConditionsDialogProps> = ({ open }) => {
	const { acceptTerms } = useAuth();

	const handleAccept = async () => {
		await acceptTerms();
	};

	return (
		<Dialog
			open={open}
			maxWidth="md"
			slotProps={{
				paper: {
					sx: {
						borderRadius: "8px",
						boxShadow: `0px 4px 20px ${alpha(INK_BLACK, 0.1)}`,
						width: "100%",
						maxWidth: "800px",
						height: "auto",
						maxHeight: "80vh",
						display: "flex",
						flexDirection: "column",
					},
				},
			}}
		>
			<DialogTitle
				sx={{
					fontSize: "1.5rem",
					fontWeight: 600,
					color: INK.PRIMARY,
					p: 3,
					borderBottom: `1px solid ${NEUTRAL[200]}`,
				}}
			>
				In-House Health: User Terms and Conditions
			</DialogTitle>
			<DialogContent
				sx={{
					p: 3,
					overflowY: "auto",
					"&::-webkit-scrollbar": {
						width: "8px",
						height: "8px",
					},
					"&::-webkit-scrollbar-track": {
						backgroundColor: NEUTRAL[100],
						borderRadius: "4px",
					},
					"&::-webkit-scrollbar-thumb": {
						backgroundColor: NEUTRAL[400],
						borderRadius: "4px",
						"&:hover": {
							backgroundColor: NEUTRAL[500],
						},
					},
					scrollbarWidth: "thin",
					scrollbarColor: `${NEUTRAL[400]} ${NEUTRAL[100]}`,
				}}
			>
				<TermsContent />
			</DialogContent>
			<DialogActions
				sx={{
					p: 3,
					borderTop: `1px solid ${NEUTRAL[200]}`,
					display: "flex",
					justifyContent: "flex-end",
				}}
			>
				<Button
					onClick={handleAccept}
					variant="contained"
					color="primary"
					sx={{
						borderRadius: "8px",
						px: 4,
						py: 1,
						textTransform: "none",
						fontWeight: 500,
					}}
				>
					I Accept the Terms and Conditions
				</Button>
			</DialogActions>
		</Dialog>
	);
};
